import { MapPin, MessageCircle, MessageSquare, Star, Users } from 'lucide-react';
import { StatCard, Sparkline } from '../ui';

export interface OverviewStatCardsProps {
  rating: { value: number; sparkline: Array<{ value: number }>; change?: number };
  totalReviews: { value: number };
  unansweredReviews: { value: number; change?: number };
  competitorPosition: { value: number | null; sparkline: Array<{ value: number }>; change?: number };
  visits: { value: number; sparkline: Array<{ value: number }>; change?: number };
  loading: boolean;
}

export function OverviewStatCards({ rating, totalReviews, unansweredReviews, competitorPosition, visits, loading }: OverviewStatCardsProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white rounded-xl border border-gray-200 shadow-card p-6 h-[124px] flex items-center justify-center text-gray-400 text-sm">
            Загрузка...
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
      <StatCard
        title="Рейтинг"
        value={rating.value > 0 ? rating.value.toFixed(1) : '—'}
        change={rating.change}
        icon={Star}
        iconColor="orange"
        sparkline={<Sparkline data={rating.sparkline} color="#f97316" />}
      />
      <StatCard
        title="Всего отзывов"
        value={totalReviews.value}
        icon={MessageCircle}
        iconColor="blue"
      />
      <StatCard
        title="Отзывы без ответа"
        value={unansweredReviews.value}
        change={unansweredReviews.change}
        icon={MessageSquare}
        iconColor={unansweredReviews.value > 0 ? 'red' : 'primary'}
      />
      <StatCard
        title="Место среди конкурентов"
        value={competitorPosition.value !== null ? `#${competitorPosition.value}` : '—'}
        change={competitorPosition.change}
        icon={Users}
        iconColor="purple"
        sparkline={<Sparkline data={competitorPosition.sparkline} color="#9333ea" reversed />}
      />
      <StatCard
        title="Визиты"
        value={visits.value}
        change={visits.change}
        icon={MapPin}
        iconColor="green"
        sparkline={<Sparkline data={visits.sparkline} color="#16a34a" />}
      />
    </div>
  );
}
